import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/main.css";
import IconBase from "./components/IconBase.vue";

Vue.config.productionTip = false;

// 全局注册 Icon 组件，因为所有子组件都用到它
Vue.component("icon-base", IconBase);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
